// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { ReactComponent as ExpandMoreIcon } from '../../../../assets/Icons/lucideIcons/chevron-down.svg';

import { DraftValuesCountChip } from '../../AttributesForm/FieldComponents/DraftFieldExtras';

const SectionAccordion = ({
  title,
  draftCount = 0,
  defaultExpanded = true,
  children,
  className,
  sx = {},
  icon = null,
  accordionUseForMenu = false,
  variant = 'body6',
}) => {
  const theme = useTheme();

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      className={className}
      sx={{
        border: `1px solid ${theme?.palette?.divider}`,
        borderRadius: '4px !important',
        '&:before': { display: 'none' },
        overflow: 'hidden',
        m: 0,
        pl: 0,
        '&.Mui-expanded': {
          m: 0,
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{
              color: theme?.palette?.entityOverview?.IconColor,
              fontSize: 'large',
            }}
          />
        }
        sx={[
          {
            minHeight: 36,
            background:
              theme?.palette?.entityOverview?.accordionTitleBackground,
            '& .MuiAccordionSummary-content': {
              margin: 0,
              alignItems: 'center',
            },
          },
          accordionUseForMenu ? { pl: 1 } : { px: 2, py: 1.5 },
        ]}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            minWidth: 0,
            flex: 1,
          }}
        >
          {icon && <Box sx={{ mr: accordionUseForMenu ? 0 : 1 }}>{icon}</Box>}
          <Typography variant={variant}>{title}</Typography>
          <DraftValuesCountChip count={draftCount} />
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ px: 2, py: 1 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

SectionAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  draftCount: PropTypes.number,
  defaultExpanded: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.node,
  accordionUseForMenu: PropTypes.bool,
  sx: PropTypes.objectOf(PropTypes.string).isRequired,
  variant: PropTypes.string,
};

export default SectionAccordion;
